import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import MaskedInput from 'react-maskedinput'

class RegisterUser extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
        this.sendRequest = this.sendRequest.bind(this);

        this.state = {
            user: {},
            token: {},
            promo: {},
            tdc: "",
            internalIP: "",
            coupons: [],
            loading: false,
            equalMail: null,
            terms: false,
            pdfUrl: "",
            success: false
        };
    }

    componentWillMount()
    {
        let self = this;
        /*
        let user = self.state.user;

        user['folio_desclub'] = '1993 XXXX XXXX XXXX';
        user['name'] = 'Jesús TEST';

        self.setState({
            user: user,
            success: true
        });
        */
    }

    componentDidMount()
    {
        let self = this;

        window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;//compatibility for Firefox and chrome
        let pc = new RTCPeerConnection({iceServers: []}), noop = function () {
        };
        pc.createDataChannel('');//create a bogus data channel
        pc.createOffer(pc.setLocalDescription.bind(pc), noop);// create offer and set local description
        pc.onicecandidate = function (ice) {
            if (ice && ice.candidate && ice.candidate.candidate) {
                let myIP = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
                self.setState({
                    internalIP: myIP
                });
                pc.onicecandidate = noop;
            }
        };

    }

    handleChange({target}) {
        let self = this;

        let user = self.state.user;
        user[target.id] = target.value;

        if (target.id === 'email' || target.id === 'email2') {
            let email2 = $('#email2').val();

            if (self.state.user.email === email2)
                self.setState({
                    equalMail: true
                });
            else
                self.setState({
                    equalMail: false
                });
        }

        self.setState({
            user: user
        });

    }

    save()
    {
        let self = this;
        let user = self.state.user;

        if (!user['name'] || !user['email'] || !user['birthday']) {
            swal({
                title: "¡Oh no!",
                text: "Para poder continuar, debes completar todos los campos.",
                icon: "warning",
            });

            return null;
        } else {
            if (user['email'] === user['email2']) {
                user['internalIP'] = self.state.internalIP;
                    swal({
                        title: 'Un momento...',
                        text: 'Estamos procesando tu solicitud.',
                        buttons: false,
                        showCancelButton: false,
                        showConfirmButton: false,
                        closeOnClickOutside: false,
                    });

                    self.setState({
                        user: user
                    });

                    self.sendRequest();
            } else {
                swal({
                    title: "¡Oh no!",
                    text: "El correo electrónico no coincide.",
                    icon: "warning",
                });
            }
        }

    }

    sendRequest() {
        let self = this;

        axios.post(location.origin + '/api/customers/register/' + project, self.state.user)
            .then(response => {
                $("#customerForm").remove();
                let user_empty = {};

                self.setState({
                    user: user_empty,
                    success: true
                });

                let response_type = response.data.type;
                let response_user = response.data.data;

                if (response_type === "new")
                    swal({
                        title: "¡Bien!",
                        text: "Te hemos enviado un correo electrónico con tus credenciales de acceso.",
                        icon: "success",
                    });
                else if (response_type === "exists")
                    swal({
                        title: "¡Bien!",
                        text: "Te hemos enviado un correo electrónico para recordar tus credenciales de acceso.",
                        icon: "success",
                    });

                self.setState({
                    user: response_user
                });

            })
            .catch(error => {
                let err = error.response.data;

                switch (err) {
                    case 'already_registered':
                        swal({
                            title: "¡Oh no!",
                            text: "El número de tarjeta Sí Vale ya se encuentra registrado.",
                            icon: "warning",
                        });
                        break;
                    case "invalid_tdc":
                        swal({
                            title: "¡Oh no!",
                            text: "El número de tarjeta no es válido.",
                            icon: "warning",
                        });
                        break;
                    case "NO_TIENE":
                        swal({
                            title: "¡Oh no!",
                            text: "El número de tarjeta ingresado no tiene activado el producto DESCLUB PLAN DE PROTECCIÓN FAMILIAR DEL GOOD 2 GREAT CLUB, llama al (55) 5328 1003 y actívalo ahora.",
                            icon: "warning",
                        });
                        break;
                    default:
                        swal({
                            title: "¡Oh no!",
                            text: "Ha ocurrido un error al procesar tu solicitud.",
                            icon: "warning",
                        });
                        break;
                }
            });
    }

    render() {

        return (
            <div>
                <section className="section-35 bg-whisper" style={{paddingTop: "0px"}}>
                    <div className="container text-center text-sm-left">
                        <section className="section-35 section-md-75 section-xl-100 bg-whisper">
                            <div className="container">
                                <div className="text-center">
                                    <h2 style={{ paddingTop: "0px" }}>Registro</h2>
                                </div>
                                <div className="row" style={{ marginTop: "20px" }}>
                                    <div className="col-md-6 col-md-offset-3">
                                        <br/>
                                        <form id="customerForm">
                                            <h5>Para finalizar tu registro, por favor completa el siguiente formulario:</h5>
                                            <div className="row row-30" style={{ marginTop: "25px" }}>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <h6>Nombre</h6>
                                                        <input className="form-input form-control-has-validation"
                                                               type="text" id="name" name="name"
                                                               onChange={this.handleChange}/>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <h6>Número de tarjeta Sí Vale</h6>
                                                        <MaskedInput mask="**** **** **** ****"
                                                                     id="noTdc" size="20" onChange={this.handleChange}
                                                                     className="form-input form-control-has-validation"/>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <h6>Email</h6>
                                                        <div className="form-wrap">
                                                            <input className="form-input form-control-has-validation"
                                                                   id="email" type="text" name="email"
                                                                   onChange={this.handleChange}/>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <h6>Repite tu email</h6>
                                                        <div className="form-wrap">
                                                            <input className="form-input form-control-has-validation"
                                                                   id="email2" type="text" name="email2"
                                                                   onChange={this.handleChange}/>
                                                            {
                                                                this.state.equalMail === false &&
                                                                <span className="form-validation">Correo electrónico no coincide.</span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <h6>Fecha de nacimiento</h6>
                                                        <input className="form-input form-control-has-validation"
                                                               type="date" id="birthday" name="birthday"
                                                               onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <h6>Número celular</h6>
                                                        <input className="form-input form-control-has-validation"
                                                               type="text" id="phone" name="phone"
                                                               onChange={this.handleChange}/>
                                                    </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <button className="button button-primary-outline button-block"
                                                            type="button" id="sivaleSaveButton"
                                                            onClick={this.save}>
                                                        <i className={"fa fa-save"}></i> Guardar
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                        {
                                            this.state.success === true &&
                                            <div >
                                                <h5>A continuación te mostramos el folio DESCLUB que te fue asignado:</h5>

                                                <div className="col-md-12">
                                                    <div className="col-md-10 col-md-offset-1">
                                                        <img src={location.origin + "/img/desclub.jpg"}
                                                             className="img-responsive"
                                                        style={{ zIndex: "2" }}/>
                                                        <br className="visible-xs"/>
                                                        <br className="visible-sm"/>
                                                        <h4 style={{ zIndex: "3", marginTop: "-60px", marginLeft: "15px" }}>
                                                            {this.state.user.folio_desclub}
                                                        </h4>
                                                        <h5 style={{ zIndex: "3", marginTop: "0px", marginLeft: "15px" }}>
                                                            {this.state.user.name}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>

            </div>
        );
    }
}

export default RegisterUser;

if (document.getElementById('register_user-component')) {
    ReactDOM.render(<RegisterUser />,
        document.getElementById('register_user-component'));
}


// WEBPACK FOOTER //
// ./resources/assets/react/RegisterUser.jsx